var lists_default = {
  "fontElementMap": "vXsUe",
  "orderedlist": "v-WQp",
  "bulletedlist": "OCMmu",
  "listItem": "iC8vJ"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
